import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as finalCheckActions from '../../../redux/finalCheckActions';
import * as threeDViewActions from '../../../redux/threeDViewActions';
import { bindActionCreators } from 'redux';
import './VanillaFinalCheck.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import * as pageControllerActions from '../../../redux/pageControllerActions';
import { DESIGN_SHARE_PAGE } from '../../../utilities/constants/Constants';
import { renderProject } from '../../../utilities/ProjectCanvasRenderer/ProjectCanvasRenderer';
import { Icons } from '../../../utilities';

class Preview extends Component {
  state = { previews: [], activePreviewIndex: 0 };

  componentDidMount() {
    const { dispatchers, project, multiWallProjects } = this.props;
    if (multiWallProjects && multiWallProjects.length > 1) {
      const previewResponses = [];
      multiWallProjects.forEach(tempProject => {
        const renderJson = dispatchers.threeDViewActions.renderJSONForWalls(
          tempProject,
          true
        );

        renderProject(renderJson, dataURLs => {
          const previewResponse = {};
          previewResponse.projectId = renderJson[0].projectId;
          previewResponse.URL = dataURLs;
          previewResponses.push(previewResponse);

          if (multiWallProjects.length == previewResponses.length) {
            const multiWallPreviews = this.rearrangePreviewResponse(
              previewResponses,
              multiWallProjects
            );
            this.setState({ previews: multiWallPreviews });
          }
        });
      });
    } else {
      const renderJson = dispatchers.threeDViewActions.renderJSONForWalls(
        project,
        true
      );
      renderProject(renderJson, dataURLs => {
        this.setState({ previews: dataURLs });
      });
    }
  }

  rearrangePreviewResponse = (previewResponses, multiWallProjects) => {
    let multiWallPreviews = [];
    multiWallProjects.forEach(project => {
      const projectId = project.id;
      const matchedPreviewReponse = previewResponses.filter(
        previewResponse => previewResponse.projectId == projectId
      )[0];
      multiWallPreviews = multiWallPreviews.concat(matchedPreviewReponse.URL);
    });
    return multiWallPreviews;
  };

  canShowLeftNavigateToPreview = () => {
    const { activePreviewIndex } = this.state;
    return activePreviewIndex > 0;
  };

  canShowRightNavigateToPreview = () => {
    const { previews, activePreviewIndex } = this.state;
    return activePreviewIndex < previews.length - 1;
  };

  navigatePreviewHandler = type => {
    if (type == 'left') {
      this.setState(prevState => ({
        activePreviewIndex: prevState.activePreviewIndex - 1
      }));
    }
    if (type == 'right') {
      this.setState(prevState => ({
        activePreviewIndex: prevState.activePreviewIndex + 1
      }));
    }
  };

  navigateButton = type => {
    let icon = Icons.previewNavigateRight;
    if (type == 'left') {
      icon = Icons.previewNavigateLeft;
    }
    return (
      <button
        type='button'
        style={{ border: 'none', background: 'none', outline: 'none' }}
        onClick={() => {
          this.navigatePreviewHandler(type);
        }}
      >
        <img
          src={icon}
          style={{ width: '30px', height: '30px' }}
          alt='navigate'
        />
      </button>
    );
  };

  render() {
    const {
      storeData,
      selectedDefaultSize,
      orientation,
      currentPageIndex,
      projectName,
      finalcheck,
      dispatchers,
      envData
    } = this.props;

    const { previews, activePreviewIndex } = this.state;

    let uiSize;
    if (!finalcheck) {
      if (selectedDefaultSize === Constants.CUSTOM_SIZE) {
        uiSize = `${selectedDefaultSize
          .charAt(0)
          .toUpperCase()}${selectedDefaultSize.slice(1)}`;
      } else {
        uiSize = `${storeData.fixedSizes[selectedDefaultSize].name} ${Constants.HYPHEN} ${orientation}`;
      }
    }
    return (
      <div className='final-poster-design'>
        {!finalcheck && <text className='text poster-name'>{projectName}</text>}
        <div
          id='final-design'
          style={{ display: 'flex', width: '250px', height: '250px' }}
        >
          {this.canShowLeftNavigateToPreview()
            ? this.navigateButton('left')
            : null}
          {previews.length > 0 && (
            <img
              style={{
                objectFit: 'contain',
                width: 'inherit',
                height: 'inherit'
              }}
              src={previews[activePreviewIndex].image_data}
              alt='preview'
            />
          )}
          {this.canShowRightNavigateToPreview()
            ? this.navigateButton('right')
            : null}
        </div>
        {!finalcheck && <p className='text size'>{uiSize}</p>}
        {currentPageIndex !== DESIGN_SHARE_PAGE && !finalcheck ? (
          <button
            type='button'
            className='button nutral-primary-default'
            onClick={() =>
              dispatchers.finalCheckActions.onEditDesign(
                dispatchers.pageControllerActions.setCurrentPageIndex,
                envData.category
              )
            }
          >
            {string.EDIT_DESIGN_BUTTON_TITLE_KEY}
          </button>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    project: state.finalCheck.project,
    storeData: state.modal.storeData,
    orientation: state.home.orientation,
    multiWallProjects: state.finalCheck.multiWallProjects,
    selectedDefaultSize: state.home.selectedDefaultSize,
    currentPageIndex: state.pageController.currentPageIndex,
    envData: state.modal.envData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      threeDViewActions: bindActionCreators(threeDViewActions, dispatch),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch),
      pageControllerActions: bindActionCreators(pageControllerActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
